"use client";

import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import MedicalAidOrderDetailContent from "./medicalAidOrderDetailContent";

export default function MedicalAidOrderDetailView() {
  const navigate = useNavigate();
	const location = useLocation();
	const recieptno = location.state?.recieptno || null;

  return <MedicalAidOrderDetailContent navigate={navigate} recieptno={recieptno} />;
}
